import axios from 'axios'

// Request interceptors

axios.interceptors.request.use((config) => {
  config.params = Object.assign({}, config.params, { client: 'clinical-portal' })

  return config
}, (error) => Promise.reject(error))
